// import React, { useState, useEffect } from "react";
// import { DropZone } from "../../core";

// // Draggable Component
// const DraggableComponent = ({ onDragStart }) => {
//   return (
//     <div
//       draggable
//       onDragStart={onDragStart}
//       style={draggableComponentStyle}
//     >
//       <img
//                 src="https://dev-cmsautomations.s3.amazonaws.com/assets/web-version/aa283573-2d7f-40c2-90b2-0cf2b347f23d-web.jpg" 
//                 alt="Draggable Image"
//                 style={imageStyle}
//               />
//     </div>
//   );
// };

// const imageStyle = {
//   width: "100%",
//   height: "auto",
//   borderRadius: "4px",
//   marginBottom: "10px",
// };

// // Modal Component with Drop Area
// const Modal = ({ isOpen, onClose }) => {
//   const [droppedItem, setDroppedItem] = useState(null);

//   const handleDragOver = (e) => {
//     e.preventDefault(); // Prevent the default behavior to allow the drop
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     const draggedItem = e.dataTransfer.getData("text");
//     setDroppedItem(draggedItem); // Handle the dropped item
//   };

//   // Add global dragover listener
//   useEffect(() => {
//     const globalDragOver = (e) => {
//       e.preventDefault(); // Prevent the default behavior for the whole document
//     };

//     // Attach the event listener globally
//     document.addEventListener("dragover", globalDragOver);

//     // Clean up event listener on unmount
//     return () => {
//       document.removeEventListener("dragover", globalDragOver);
//     };
//   }, []);

//   if (!isOpen) return null;

//   return (
//     <div style={modalOverlayStyle}>
//       <div
//         style={modalContentStyle}
//         onDragOver={handleDragOver} // Use the defined handleDragOver
//         onDrop={handleDrop}
//       >
//         <button onClick={onClose} style={closeButtonStyle}>
//           &times;
//         </button>
//         <h1>Image</h1>
//         <DropZone />
//         <DraggableComponent onDragStart={(e) => e.dataTransfer.setData("text", "imageItem")} />
//         {/* Draggable component */}
//         {droppedItem && <div style={droppedItemStyle}>Dropped: {droppedItem}</div>}
//       </div>
//     </div>
//   );
// };

// // Styles
// const modalOverlayStyle = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   backgroundColor: "rgba(0, 0, 0, 0.5)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   zIndex: 1000,
// };

// const modalContentStyle = {
//   backgroundColor: "#fff",
//   padding: "20px",
//   borderRadius: "8px",
//   width: "300px",
//   height: "500px",
//   textAlign: "left",
//   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//   overflow: "auto",
//   position: "relative",
// };

// const closeButtonStyle = {
//   position: "absolute",
//   top: "10px",
//   right: "10px",
//   fontSize: "20px",
//   border: "none",
//   background: "none",
//   cursor: "pointer",
// };

// const draggableComponentStyle = {
//   padding: "10px",
//   backgroundColor: "#4CAF50",
//   color: "white",
//   borderRadius: "5px",
//   cursor: "move",
//   textAlign: "center",
//   marginBottom: "20px",
// };

// const droppedItemStyle = {
//   padding: "10px",
//   backgroundColor: "#FFEB3B",
//   color: "black",
//   borderRadius: "5px",
//   marginTop: "20px",
//   textAlign: "center",
// };

// export default Modal;


import React, { useState } from "react";
// import Draggables from "./draggable";
import Draggables from "./draggable";
const Modal = ({ isOpen, onClose }) => {
  

  if (!isOpen) return null;

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <button onClick={onClose} style={closeButtonStyle}>
          &times;
        </button>
      <h1>Image</h1>
        <Draggables onClose={onClose} onDragStart/> 
        {/* Pass onDragStart handler */}
      </div>
     
    </div>
  );
};

// Styles
const modalOverlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "flex-start",
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  position: "absolute",
  top: "20px", 
  left: "20px", 
  width: "300px",
  height: "500px",
  textAlign: "left",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  fontSize: "20px",
  border: "none",
  background: "none",
  cursor: "pointer",
};

export default Modal;
